import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { getDateDiff, getInputValueCheck, getMatchingSelectData, runFormFunction, setFormClass } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumnField, DataColumnRecord } from "../../input/inputType";
import { getIntArray } from "@/util/arrayutil";
import { checkEmpty } from "@/util/stringutil";
import { qcCommonCols, qcCommonInit } from "../../inputCols/qcCols";
import { beaninfoGreenbeanCol, beaninfoGreenbeanList, beaninfoLossCols, beaninfoNameCols } from "../../inputCols/beaninfoCols";
import { enLocale } from "@/i18n/routing";
import { brewingChangeCalc, brewingCount, brewingDefault } from "../../inputCols/brewingCols";
const beainInfoCommonInit = (
  data: any,
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  detail?: boolean,
) => {
  Debug("beainInfoCommonInit", data);
  qcCommonInit(data, form, formMemo, formFunction, dataFunction);
  const country_list =
    data.blending_country_list instanceof Array
      ? data.blending_country_list
      : typeof data.blending_country_list === "string"
        ? data.blending_country_list.split(",")
        : [];
  const country_code = country_list.length > 0 ? country_list[0] : undefined;
  setTimeout(() => {
    if (country_code) {
      runFormFunction(formFunction, "blending_country_map", "setSelectCountry", [country_code]);
      setTimeout(() => {
        runFormFunction(formFunction, "blending_country_map", "setSelectCountry", [country_code]);
      }, dc.setTimeoutDelay * 4);
    }
    if (detail) {
      const blending_result_date = getInputValueCheck(form, formMemo, dataFunction, data, "blending_result_date");
      const cupnote_date = dayjs();
      form?.setFieldsValue({ cupnote_date, brewing_date_term: getDateDiff(blending_result_date, cupnote_date) });
    }
  }, dc.setTimeoutDelay);

  // const brewing_list_use = getInputValueCheck(form, formMemo, dataFunction, data, "brewing_list_use");
  // const functionMode = brewing_list_use ? "removeFormClass" : "addFormClass";
  // if (dataFunction && dataFunction[functionMode]) {
  //   dataFunction[functionMode]("hide_brewing_result");
  // }
};
export const BeanInfo = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  const defaultTimer = dc.brewingTimer;

  const utcOffset = dayjs().utcOffset() * 60000;

  const brewingCommon = brewingDefault(
    t,
    form,
    formMemo?.current,
    formFunction?.current,
    dataFunction?.current,
    params?.setTimer,
    params?.locale,
    "info",
    "beaninfo",
    true,
  );

  const brewingList: DataColumnRecord = {
    div_brewing_1: { ...dc.itemDiv, display: { brewing_list_use: 1 } },
    info_brewing_list: {
      ...dc.select,
      placeholder: "brewing_list_select",
      placeholderForce: true,
      inputClassName: "w-full",
      widthFull: true,
      label: "brewing_list",
      labelClassName: dc.strongLabelClassName,
      dataValueList: ["brewing_list"],
      variant: "outlined",
      dataLabel: {
        value: "brewing_seq",
        label:
          params?.locale === enLocale
            ? { field: "brewing_name", subs: "brewing_name_locale" }
            : { field: "brewing_name_locale", subs: "brewing_name" },
      },
      noItem: false,
      disabled: false,
      readInput: true,
      readInputDisabled: false,
      display: { brewing_list_use: 1 },
      onChange: (e: any) => {
        Debug(e);

        const setValues = form?.current?.getFieldsValue([
          "blending_country_list",
          "blending_region_seq",
          "blending_region_seq",
          "blending_farm_seq",
          "blending_variety_list",
          "blending_grade_list",
          "blending_grade_detail_list",
          "blending_process_list",
        ]);
        const emptys: string[] = [];
        const emptyFields: string[] = [];
        if (e.value) {
          const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "info_brewing_list");
          if (result) {
            // Debug(result);

            form?.current?.setFieldsValue(result);
            const brewing_result_use = e.value !== undefined;
            const fills: string[] = [];
            const fillFields: string[] = [];
            const emptyList = [
              "brewing_type",
              "brewing_machine_seq",
              "brewing_grinder_seq",
              "brewing_dripfilter_seq",
              "brewing_before",
              "brewing_after",
              "brewing_rdt",
              "brewing_water",
            ].forEach((item) => {
              if (checkEmpty(result[item])) {
                emptys.push(item);
              } else {
                fills.push(item);
              }
            });
            const rowEmptys: Record<string, string[]> = {
              brewing_grinder_detail: ["brewing_grinder_zeropoint", "brewing_grinder_temp", "brewing_grinder_rpm"],
              brewing_grinder_setting: ["brewing_bean_mass", "brewing_grinder_point", "brewing_grinder_term"],
              brewing_detail_1: ["brewing_water_hard", "brewing_water_alk", "brewing_water_tds"],
              brewing_detail_2: ["brewing_shower", "brewing_basket", "brewing_temper"],
              brewing_detail_3: ["brewing_wdt", "brewing_dist", "brewing_temping_bar"],
            };
            const rowEmptyKeys = Object.keys(rowEmptys);
            rowEmptyKeys.forEach((row) => {
              if (rowEmptys[row].every((item) => checkEmpty(result[item]))) {
                emptys.push(row);
              } else {
                fills.push(row);
              }
            });
            getIntArray(brewingCount, 1, (i) => {
              const str = "brewing_step" + i;
              if (checkEmpty(result[str + "_term"])) {
                emptys.push(str);
              } else {
                fills.push(str);
                if (checkEmpty(result[str + "_comment"])) {
                  emptyFields.push(str + "_comment");
                } else {
                  fillFields.push(str + "_comment");
                }
              }
            });

            setFormClass(dataFunction?.current, {
              brewing_detail_use: result.brewing_detail_use ?? false,
              brewing_espresso_use: result.brewing_type === "ESP",
              brewing_drip_use: result.brewing_type === "DRP",
              hidden_step_detail: !((result.brewing_step_use ?? 0) === 1),
              hidden_brewing_result: !brewing_result_use,
              // satis_detail_use: satis_detail_use,
            });
            runFormFunction(formFunction?.current, fills, "setItemDisplay", true);
            runFormFunction(formFunction?.current, fillFields, "setDisplay", true);
          }
        } else {
          setFormClass(dataFunction?.current, {
            // satis_detail_use: satis_detail_use,
            hidden_brewing_result: true,
          });
        }
        setTimeout(() => {
          Object.keys(setValues).forEach((key) => {
            if (checkEmpty(setValues[key])) {
              emptys.push(key);
            }
          });
          runFormFunction(formFunction?.current, emptys, "setItemDisplay", false);
          runFormFunction(formFunction?.current, emptyFields, "setDisplay", false);
          if (e.value) {
            brewingChangeCalc(form?.current, dataFunction?.current);
          }
        }, dc.setTimeoutShort);
      },
      displayCheckIds: ["brewing_list"],
    },
    // div_brewing_2: { ...dc.itemDiv, display: { brewing_list_use: 1 }, itemClassName: dc.itemDiv.itemClassName + " brewing_result" },
    ...brewingCommon,
  };

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "BeanInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/info/roaster/bean/default" },
        dataResultName: "detail_result",
        dataName: "BeanInfo",
        dataFormClassDefault: ["hidden_brewing_result"],
        useDefaultId: false,
        editCheck: true,
        useList: false,
        timer: defaultTimer,
        dataInit: (data: any) => {
          beainInfoCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          info_uuid: {
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              blending_uuid_str: {
                ...dc.input,
                widthFull: false,
                inputClassName: dc.inputCountryClassName,
              },
              blending_uuid_link: {
                ...dc.link,
                fieldId: "blending_uuid_str",
                linkOption: {
                  pathname: "/user/usernote/coffeenote/write?type=RSTRDF&serial=",
                },
                linkPropOption: {
                  title: " ",
                  linkButtonNewTab: false,
                  linkButtonName: "NotePencil",
                  linkButtonTitle: "note_write_label",
                  linkButtonFront: "just",
                },
                checkUserType: ["SADMIN", "ADMIN", "TESTER", "PAID", "USER"],
                edit: { display: false },
                saveData: false,
              },
              blending_register_link: {
                ...dc.link,
                fieldId: "blending_uuid_str",
                linkOption: { pathname: "/cafe/coffeebean/qrdefault/" },
                linkPropOption: {
                  title: " ",
                  linkButtonName: "ListPlus",
                  linkButtonFront: "just",
                  linkButtonTitle: "register_label",
                  // linkButtonTitleTooltip: false,
                  linkButtonNewTab: false,
                },
                checkUserAuth: { cafe: ["BARISTA", "SAST", "MNG", "SMNG", "OWN"] },
              },
            },
          },
          ...beaninfoNameCols(form, formFunction?.current, params?.locale),
          greenbean_seq: beaninfoGreenbeanCol(form, formFunction?.current, params?.locale),
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
          ...brewingList,
        },
        listColLinkField: ["blending_uuid"],
        base64Field: ["blending_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    case "BeanDetail":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/info/roaster/bean/detail" },
        dataResultName: "detail_result",
        dataName: "BeanDetail",
        dataFormClassDefault: ["hidden_brewing_result"],
        useDefaultId: false,
        editCheck: true,
        useList: false,
        timer: defaultTimer,
        dataInit: (data: any) => {
          beainInfoCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current, true);
        },
        dataCols: {
          info_uuid: {
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              blending_result_uuid_str: {
                ...dc.input,
                widthFull: false,
                inputClassName: dc.inputCountryClassName,
              },
              blending_result_uuid_link: {
                ...dc.link,
                fieldId: "blending_result_uuid_str",
                linkOption: {
                  pathname: "/user/usernote/coffeenote/write?type=RSTRDT&serial=",
                },
                linkPropOption: {
                  title: " ",
                  linkButtonNewTab: false,
                  linkButtonName: "NotePencil",
                  linkButtonTitle: "note_write_label",
                  linkButtonFront: "just",
                },
                checkUserType: ["SADMIN", "ADMIN", "TESTER", "PAID", "USER"],
                edit: { display: false },
                saveData: false,
              },
              blending_register_link: {
                ...dc.link,
                fieldId: "blending_result_uuid_str",
                linkOption: { pathname: "/cafe/coffeebean/qrreceived/" },
                linkPropOption: {
                  title: " ",
                  linkButtonName: "ListPlus",
                  linkButtonFront: "just",
                  linkButtonTitle: "register_label",
                  // linkButtonTitleTooltip: false,
                  linkButtonNewTab: false,
                },
                checkUserAuth: { cafe: ["BARISTA", "SAST", "MNG", "SMNG", "OWN"] },
              },
            },
          },

          ...beaninfoNameCols(form, formFunction?.current, params?.locale, true),
          ...beaninfoLossCols,
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          blending_uuid_str: {
            ...dc.qrcode,
            label: "beaninfo_label",
            linkPropOption: { ...dc.qrcode.linkPropOption, linkButtonTitle: "link", linkButtonNewTab: false },
            linkOption: { pathname: "/info/bean/rd/" },
          },
          blending_uuid: {
            fieldId: "blending_uuid_str",
            label: "product_serial",
            inputType: "display",
            valueClassName: "font-bold",
          },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },

          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
          ...brewingList,
        },
        listColLinkField: ["blending_result_uuid"],
        base64Field: ["blending_result_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    case "CafeBeanInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/info/cafe/bean/default" },
        dataResultName: "detail_result",
        dataFormClassDefault: ["hidden_brewing_result"],
        dataMerge: ["blending_result", "cupnote_result"],
        dataName: "CafeBeanInfo",
        useDefaultId: false,
        editCheck: true,
        useList: false,
        timer: defaultTimer,
        dataInit: (data: any) => {
          beainInfoCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          info_uuid: {
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              coffeebean_uuid_str: {
                ...dc.input,
                widthFull: false,
                inputClassName: dc.inputCountryClassName,
              },
              coffeebean_uuid_link: {
                ...dc.link,
                fieldId: "coffeebean_uuid_str",
                linkOption: {
                  pathname: "/user/usernote/coffeenote/write?type=CAFEDF&serial=",
                },
                linkPropOption: {
                  title: " ",
                  linkButtonNewTab: false,
                  linkButtonName: "NotePencil",
                  linkButtonTitle: "note_write_label",
                  linkButtonFront: "just",
                },
                checkUserType: ["SADMIN", "ADMIN", "TESTER", "PAID", "USER"],
                edit: { display: false },
                saveData: false,
              },
            },
          },
          ...beaninfoNameCols(form, formFunction?.current, params?.locale),
          blending_info_use: { ...dc.use, itemClassName: "hidden", noItem: false },
          greenbean_seq: beaninfoGreenbeanCol(form, formFunction?.current, params?.locale),
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
          ...brewingList,
        },
        listColLinkField: ["coffeebean_uuid"],
        base64Field: ["coffeebean_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    case "CafeBeanDetail":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/info/cafe/bean/detail" },
        dataResultName: "detail_result",
        dataName: "CafeBeanDetail",
        dataFormClassDefault: ["hidden_brewing_result"],
        dataMerge: ["blending_result", "cupnote_result"],
        useDefaultId: false,
        editCheck: true,
        useList: false,
        timer: defaultTimer,
        dataInit: (data: any) => {
          beainInfoCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current, true);
        },
        dataCols: {
          info_uuid: {
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              received_uuid_str: {
                ...dc.input,
                widthFull: false,
                inputClassName: dc.inputCountryClassName,
              },
              received_uuid_link: {
                ...dc.link,
                fieldId: "received_uuid_str",
                linkOption: {
                  pathname: "/user/usernote/coffeenote/write?type=CAFEDT&serial=",
                },
                linkPropOption: {
                  title: " ",
                  linkButtonNewTab: false,
                  linkButtonName: "NotePencil",
                  linkButtonTitle: "note_write_label",
                  linkButtonFront: "just",
                },
                checkUserType: ["SADMIN", "ADMIN", "TESTER", "PAID", "USER"],
                edit: { display: false },
                saveData: false,
              },
            },
          },
          ...beaninfoNameCols(form, formFunction?.current, params?.locale),
          blending_info_use: { ...dc.use, itemClassName: "hidden", noItem: false },
          greenbean_seq: beaninfoGreenbeanCol(form, formFunction?.current, params?.locale),
          ...beaninfoLossCols,
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          coffeebean_uuid_str: {
            ...dc.qrcode,
            label: "beaninfo_label",
            linkPropOption: { ...dc.qrcode.linkPropOption, linkButtonTitle: "link", linkButtonNewTab: false },
            linkOption: { pathname: "/info/bean/cd/" },
          },
          coffeebean_uuid: {
            fieldId: "coffeebean_uuid_str",
            label: "product_serial",
            inputType: "display",
            valueClassName: "font-bold",
          },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },

          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
          ...brewingList,
        },
        listColLinkField: ["received_uuid"],
        base64Field: ["received_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    default:
      return undefined;
  }
};
